<template>
  <div class="stationSelect flex-ac flex-sb" v-if="show">
    <!-- v-if="left_list.length > 0" -->
    <div class="left scroll">
      <div class="leftTitle flex-ac flex-start">
        <img src="@/assets/images/cd.png" /> 行政区划
      </div>
      <div class="leftTree scroll">
        <el-tree
          v-if="treeLevelCount != 99"
          v-show="treeShow"
          :data="left_list"
          :show-checkbox="sum ? false : true"
          default-expand-all
          node-key="value"
          ref="tree"
          highlight-current
          :props="defaultProps"
          @node-click="treeLabelClick"
          :expand-on-click-node="false"
          @check="treeCheckClick"
          :render-content="renderContentMedia"
        >
          <template
            slot-scope="{ node }"
            v-if="node.label.split('@')[1] !== defaultType"
          >
            <span class="custom-tree-node">
              <span style="font-size: 12px">{{
                node.label.split("@")[0]
              }}</span>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div
      class="right flex-ac fw"
      :style="{ width: left_list.length > 0 ? 'calc(100% - 150px)' : '100%' }"
      v-if="defaultQuery"
    >
      <div class="top flex-ac flex-sb">
        <div class="flex-ac">
          <div
            class=""
            v-for="(it, i) in page || page == 'networkCamera'
              ? stationTags
                  .filter((v) => v.label == '视频监控')
                  .filter(
                    (v) =>
                      !defaultQuery.StationIds_ExcludeStationTagType.includes(
                        v.value
                      )
                  )
              : stationTags
                  .filter((v) => v.label != '视频监控')
                  .filter(
                    (v) =>
                      !defaultQuery.StationIds_ExcludeStationTagType.includes(
                        v.value
                      )
                  )"
            :key="i"
            @click="stationTagsClick(it, i)"
            :class="stationTagsOn == it.value ? 'stationTagsOn' : ''"
          >
            {{ it.label }}
          </div>
          <div
            class=""
            @click="
              stationTagsClick(
                {
                  label: '停运站点',
                  value: '999',
                },
                999
              )
            "
            :class="stationTagsOn == 999 ? 'stationTagsOn' : ''"
          >
            停运站点
          </div>
        </div>
        <div class="flex-ac">
          <el-input
            v-model="fiterLabel"
            size="mini"
            placeholder="请输入内容"
            ref="fiterLabelInput"
            clearable
          />
          <!-- v-show="fiterLabelShow" -->
          <!-- @blur="fiterLabelShowFunc(false)" -->
          <i
            class="el-icon-search"
            style="
              font-size: 16px;
              color: rgba(64, 158, 255, 1);
              cursor: pointer;
            "
          />
          <!-- @click="fiterLabelShowFunc(true)" -->
        </div>
      </div>
      <div class="cen scroll fw flex-start">
        <template v-for="(it, i) in cen_list">
          <div class="list" :key="i" v-if="it.show && !it.attributes.Outage">
            <div
              @click="listClick(it, i)"
              class="flex-ac"
              :class="it.click ? 'listOn' : ''"
            >
              <el-tooltip
                class="item"
                effect="dark"
                placement="top-start"
                :enterable="false"
                :open-delay="500"
              >
                <span>{{ it.label }}</span>
                <div slot="content">
                  <p class="parentsTooltip1">{{ it.label }}</p>
                  <p
                    class="parentsTooltip2"
                    v-if="
                      it.attributes.ParentStations &&
                      it.attributes.ParentStations.length > 0
                    "
                  >
                    <span
                      v-for="(item, p) in it.attributes.ParentStations"
                      :key="item.label"
                      >{{ item.label
                      }}<i v-if="p < it.attributes.ParentStations.length - 1"
                        >/</i
                      ></span
                    >
                  </p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template v-for="(it, i) in cen_list">
          <div class="list" :key="i" v-if="it.show && it.attributes.Outage">
            <div
              @click="listClick(it, i)"
              class="flex-ac"
              :class="it.click ? 'listOn' : ''"
            >
              <el-tooltip
                class="item"
                effect="dark"
                placement="top-start"
                :enterable="false"
                :open-delay="500"
              >
                <span>{{ it.label }}</span>
                <div slot="content">
                  <p class="parentsTooltip1">{{ it.label }}</p>
                  <p
                    class="parentsTooltip2"
                    v-if="
                      it.attributes.ParentStations &&
                      it.attributes.ParentStations.length > 0
                    "
                  >
                    <span
                      v-for="(item, p) in it.attributes.ParentStations"
                      :key="item.label"
                      >{{ item.label
                      }}<i v-if="p < it.attributes.ParentStations.length - 1"
                        >/</i
                      ></span
                    >
                  </p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
      </div>
      <div class="bottom flex-ac flex-sb">
        <div>
          <template v-if="!sum">
            <el-button size="mini" @click="allClick(true)">全选</el-button>
            <el-button size="mini" @click="allClick(false)">取消全选</el-button>
            <span style="margin-left: 5px; color: #999; font-size: 12px">
              (已选中：{{ selectLength }}个{{ stationTabs[defaultType] }})
            </span>
          </template>
          <el-button size="mini" @click="reversal()" v-if="hasReversal"
            >反选</el-button
          >
          <template v-if="sum">
            <span style="margin-left: 5px; color: #999; font-size: 12px"
              >限选{{ sum }}个{{ stationTabs[defaultType] }}</span
            >
            <el-button v-if="sum > 1" size="mini" @click="allClick(false)"
              >取消选择</el-button
            >
          </template>
        </div>
        <div>
          <el-button size="mini" type="primary" @click="submit(false)"
            >确认</el-button
          >
          <el-button size="mini" @click="close">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { GetStationSelect, GetParentLevelStationTree } from "@/api/baseData";
import { mapGetters } from "vuex";
export default {
  props: [
    "sum",
    "defaultStations",
    "defaultType",
    "stationsObj",
    "exe",
    "filterOutage",
    "hasReversal",
    "page",
    "defaultQuery",
  ],
  components: {},
  computed: {
    ...mapGetters(["tabsOn"]),
  },
  data() {
    return {
      show: false,
      stationTabs: {
        Station: "站点",
        Region: "区县",
        City: "城市",
        Province: "省份",
      },
      left_list: [],
      top_list: [],
      cen_list: [],
      showLevel: [],
      stationTags: [{ label: "全部", value: "" }],
      firstLoad: true,
      stationTagsOn: "",
      selectLength: 0,
      defaultProps: {
        children: "children",
        // label: "label",
        label: (data) => {
          // console.log(data.attributes.Tags[0])
          return data.label + "@" + data.attributes.Tags[0];
        },
      },
      treeValue: "",
      fiterLabel: "",
      fiterLabelShow: false,
      treeShow: false,
      treeShowTimer: null,
      treeLevelCount: 99,
    };
  },
  watch: {
    defaultStations(v) {
      // if (v && v.length) {
      //   let ind = 0;
      //   for (let i in this.cen_list) {
      //     if (v.indexOf(this.cen_list[i].value) > -1) {
      //       ind = i;
      //       break;
      //     }
      //   }
      //   this.listClick(
      //     this.cen_list.find((it) => v.indexOf(it.value) > -1),
      //     ind
      //   );
      // }

      this.cen_list.map((it, i) => {
        this.$set(this.cen_list[i], "click", v.indexOf(it.value) > -1);
      });
      this.submit(false);
    },
    defaultType(v) {
      this.firstLoad = true;
      this.getData();
    },
    cen_list(arr) {
      if (this.defaultType != "Station") {
        // let map = new Map(),
        //   list = [];
        // for (let item of arr) {
        //   if (item.attributes.ParentStations.length > 0) {
        //     map.set(
        //       item.attributes.ParentStations[
        //         item.attributes.ParentStations.length - 1
        //       ].value,
        //       item.attributes.ParentStations[
        //         item.attributes.ParentStations.length - 1
        //       ]
        //     );
        //   }
        // }
        // list = [...map.values()];
        // this.stationTags = [...[{ label: "全部", value: "" }], ...list];
        this.stationTags = [{ label: "全部", value: "" }];
      }
    },
    fiterLabel() {
      this.filterData();
    },
  },
  mounted() {
    if (
      this.stationsObj &&
      this.stationsObj.stationTags &&
      this.stationsObj.stationTags.length > 0
    ) {
      let stationTags = JSON.parse(
        JSON.stringify(this.stationsObj.stationTags)
      );
      stationTags.map((v) => {
        v.click = true;
      });
      this.stationTags = [...[{ label: "全部", value: "" }], ...stationTags];
    }
    this.getData();
  },
  methods: {
    reversal() {
      this.cen_list.map((v, i) => {
        if (v.show) {
          this.$set(this.cen_list[i], "click", !this.cen_list[i].click);
        }
      });
      this.selectLength = this.cen_list.filter((v) => v.click).length;
    },
    // 树状列表自定义 - 媒体库
    renderContentMedia(h, { node, data, store }) {
      if (this.treeShowTime) clearTimeout(this.treeShowTimer);
      this.treeShowTimer = setTimeout(() => {
        this.treeShow = true;
      }, 500);
      if (
        data.attributes.Index == this.treeLevelCount ||
        node.label.split("@")[1] == this.defaultType
      ) {
        return (
          <span class="custom-tree-node custom_hide">
            <span class="custom_tree_music" />
            <span class="custom_tree_content">{node.label.split("@")[0]}</span>
          </span>
        );
      }
      return (
        <span class="custom-tree-node">
          <span class="custom_tree_folder" />
          <span class="custom_tree_content">{node.label.split("@")[0]}</span>
        </span>
      );
    },
    // 操作dom结构，将最后一个层级隐藏
    operateDom() {
      const _this = this;
      this.$nextTick(() => {
        let dom = document.querySelectorAll(".custom_hide");
        dom.forEach((item, i) => {
          item.parentNode.parentNode.style.display = "none";
        });
        $(".custom_hide").each(function () {
          $(this)
            .parent()
            .parent()
            .parent()
            .prev()
            .children(".el-tree-node__expand-icon")
            .css("display", "none");
        });
        $(".stationSelect .left .el-checkbox__input").click(function () {
          if ($(this).attr("class").indexOf("is-indeterminate") > -1) {
            _this.treeStatus = true;
          } else if ($(this).attr("class").indexOf("is-checked") > -1) {
            _this.treeStatus = false;
          } else {
            _this.treeStatus = true;
          }
        });
      });
    },

    fiterLabelShowFunc(flag) {
      const _this = this;
      if (!flag) {
        if (_this.fiterLabel == "") {
          _this.fiterLabelShow = false;
          _this.filterData();
        } else {
          _this.fiterLabelShow = true;
        }
      } else {
        _this.fiterLabelShow = true;
        _this.$nextTick(() => {
          _this.$refs.fiterLabelInput.focus();
        });
      }
    },
    filterData(refreshTree) {
      const _this = this;
      let arr = JSON.parse(JSON.stringify(this.cen_list));
      let parentsTreeOn = [];
      // 先过滤类型
      arr.map((v, i) => {
        if (
          _this.stationTagsOn == 999
            ? v.attributes.Outage
            : (_this.stationTagsOn == "" ||
                v.attributes.Tags.indexOf(_this.stationTagsOn) > -1) &&
              (_this.treeValue == "" ||
                (v.attributes.ParentStations.length > 0 &&
                  v.attributes.ParentStations.find(
                    (v) => v.value == _this.treeValue
                  ))) &&
              (this.fiterLabel == "" || v.label.indexOf(this.fiterLabel) > -1)
        ) {
          _this.$set(arr[i], "show", true);
        } else {
          _this.$set(arr[i], "show", false);
        }
      });
      arr.map((v, i) => {
        if (arr[i].click) parentsTreeOn.push(v.value);
      });
      _this.cen_list = arr;
      this.operateDom();
      if (refreshTree) this.$refs.tree.setCheckedKeys(parentsTreeOn);
    },
    treeLabelClick(it) {
      this.treeValue = it.value;
      this.filterData(false);
    },
    treeCheckClick(it, its) {
      if (this.sum) return;
      it.show = this.treeStatus;
      this.cen_list.map((v, i) => {
        if (
          v.attributes.ParentStations.length > 0 &&
          v.attributes.ParentStations.find((v) => v.value == it.value)
        ) {
          this.$set(this.cen_list[i], "click", this.treeStatus);
        }
      });
      this.selectLength = this.cen_list.filter((v) => v.click).length;
    },
    allClick(flag) {
      this.cen_list.map((v) => {
        if (v.show) v.click = flag;
        if (v.attributes.Outage) v.click = false;
      });
      this.selectLength = this.cen_list.filter((v) => v.click).length;
      this.filterData(true);
      console.log('cenlist',this.cen_list);
    },
    submit(flag) {
      let arr = [],
        labels = [];
      this.cen_list.map((v) => {
        if (v.click) {
          v.type = this.stationTags.find(
            (tag) => v.attributes.Tags.indexOf(tag.value) > -1
          )
            ? this.stationTags.find(
                (tag) => v.attributes.Tags.indexOf(tag.value) > -1
              ).label
            : "";
          arr.push(v);
        }
      });
      if (this.tabsOn.path == "dataQuery") {
        this.$bus.$emit(
          "dataQueryStationClick",
          list.filter((v) => v.click)
        );
      }
      this.$emit("stationSelectArr", arr);
      if (!flag) {
        this.$parent.showPopper = false;
      }
    },
    close() {
      this.$parent.showPopper = false;
      this.$emit("stationSelectClose");
    },
    listClick(it, i) {
      if (!it) return;
      if (this.sum == 1) {
        this.cen_list.map((v) => {
          v.click = false;
        });
        this.$set(this.cen_list[i], "click", !it.click);
        setTimeout(() => {
          this.submit(false);
        }, 0);
      } else {
        this.$set(this.cen_list[i], "click", !it.click);
        if (this.cen_list.filter((v) => v.click).length > this.sum) {
          this.$notify({
            position: "bottom-right",
            title: "提示",
            message: `当前最多可选${this.sum}个`,
            type: "info",
          });
          this.$set(this.cen_list[i], "click", !it.click);
          return;
        }
      }
      this.selectLength = this.cen_list.filter((v) => v.click).length;
      this.filterData(true);
    },
    stationTagsClick(it) {
      this.stationTagsOn = it.value;
      this.filterData();
      this.selectLength = this.cen_list.filter((v) => v.click).length;
    },
    getNewSelect() {
      const _this = this;
      let parentStationIds = [];
      $('.stationsSelectPopover input[type="checkbox"]').each(function () {
        if ($(this).prop("checked")) parentStationIds.push($(this).attr("id"));
      });
      let tagIds = [this.defaultType];
      GetStationSelect({
        tagIds: tagIds,
        parentStationIds: this.firstLoad ? null : parentStationIds,
        filterOutage: !!this.filterOutage,
      }).then((res) => {
        if (res.code == 401) {
          this.$config.getNewToken(this, () => {
            this.getNewSelect();
          });
        } else {
          let filterFunc = (list) => {
            return _this.page || _this.page == "networkCamera"
              ? list.filter((item) =>
                  item.attributes.Tags.includes(
                    _this.stationTags.find((v) => v.label == "视频监控").value
                  )
                )
              : list.filter(
                  (item) =>
                    !item.attributes.Tags.includes(
                      _this.stationTags.find((v) => v.label == "视频监控")
                        ? _this.stationTags.find((v) => v.label == "视频监控")
                            .value
                        : ""
                    )
                );
          };

          // if (_this.firstLoad) {
          //   res.result.map((v) => {
          //     if (
          //       _this.$parent.$parent.stationOn &&
          //       _this.$parent.$parent.stationOn.length > 0
          //     ) {
          //       v.click = _this.$parent.$parent.stationOn.indexOf(v.value) > -1;
          //     } else {
          //       v.click = this.defaultStations.indexOf(v.value) > -1;
          //     }
          //   });
          //   _this.cen_list = filterFunc(res.result);
          // } else {
          //   if (res.result.length > _this.cen_list.length) {
          //     for (let a = 0; a < res.result.length; a++) {
          //       res.result[a].click = !_this.firstLoad;
          //       for (let b = 0; b < _this.cen_list.length; b++) {
          //         if (res.result[a].value == _this.cen_list[b].value) {
          //           res.result[a].click = _this.cen_list[b].click;
          //         }
          //       }
          //     }
          //     _this.cen_list = filterFunc(res.result);
          //   } else {
          //     let list = [];
          //     for (let a = 0; a < _this.cen_list.length; a++) {
          //       for (let b = 0; b < res.result.length; b++) {
          //         if (_this.cen_list[a].value == res.result[b].value) {
          //           list.push(_this.cen_list[a]);
          //         }
          //       }
          //     }
          //     _this.cen_list = filterFunc(list);
          //   }
          // }
          res.result.map((v) => {
            v.click = true;
          });
          _this.cen_list = _this.cen_list.filter(
            (v) =>
              !_this.defaultQuery.StationIds_ExcludeStationTagType.includes(
                v.attributes.Tags[1]
              )
          );
          if (this.page == "networkCamera") {
            this.$parent.$parent.defaultStations = [this.cen_list[0].value];
          }
          this.firstLoad = false;
          this.filterData(true);
          this.stationTagsClick({ label: "全部", value: "" });
          _this.$nextTick(() => {
            if (!_this.exe) {
              _this.submit(true);
            }
          });
        }
      });
    },
    getData() {
      this.show = false;
      this.treeShow = false;
      const _this = this;
      GetParentLevelStationTree({
        levelTagId: this.defaultType,
        filterOutage: !!this.filterOutage,includeStationTagTypes: null,
      }).then((res) => {
        if (res.code == 401) {
          this.$config.getNewToken(this, () => {
            this.getData();
          });
        } else {
          this.show = true;
          this.treeLevelCount = 99;
          this.left_list = res.result.tree;
          this.treeLevelCount = res.result.treeLevelCount;
          this.getNewSelect();
        }
      });
    },
  },
  destroyed() {},
};
</script>
<style lang="stylus">
.stationsSelectPopover {
  width: max-content !important;
  height: max-content !important;
  padding: 0 !important;
}

.stationSelect {
  width: 1000px;
  height: 400px;
  background: #fff;
  box-sizing: content-box;

  .left {
    width: 150px;
    height: 100%;
    border-right: 1px solid rgba(240, 240, 240, 1);
  }

  .right {
    width: calc(100% - 150px);
    height: 100%;
  }

  .top {
    width: 100%;
    height: 35px;
    padding: 0 15px;

    >div {
      width: max-content;

      >div {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-right: 20px;
        cursor: pointer;
        line-height: 30px;
      }
    }

    .stationTagsOn {
      color: rgb(17, 130, 251);
      position: relative;

      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background: rgba(64, 158, 255, 1);
        bottom: 0%;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    .el-input {
      width: 150px;
      height: 26px;
      line-height: 26px;

      .el-input__inner {
        width: 150px;
        height: 26px;
        line-height: 26px;
      }
    }
  }

  .cen {
    width: 100%;
    height: calc(100% - 35px - 50px);
    border-top: 1px solid rgba(240, 240, 240, 1);
    border-bottom: 1px solid rgba(240, 240, 240, 1);
    padding: 5px;
    align-content: flex-start;
  }

  .bottom {
    width: 100%;
    height: 50px;
    padding: 0 10px;
  }

  .el-button {
    height: 26px;
    line-height: 26px;
    padding: 5px 12px;
  }

  h1 {
    padding-left: 1em;
  }

  h2 {
    padding-left: 2em;
  }

  h3 {
    padding-left: 3em;
  }

  h4 {
    padding-left: 4em;
  }

  h1, h2, h3, h4 {
    cursor: pointer;
    line-height: 18px;
    display: inline-flex;
    align-items: center;

    input {
      margin-right: 4px;
    }
  }

  .list {
    width: 25%;
    padding: 2px 10px;
    height: max-content;
    display: inline-block;

    div {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(229, 229, 229, 1);
      padding: 6px 10px;
      height: 26px;
      font-size: 12px;
      width: 100%;
      position: relative;
      cursor: pointer;
      color: #666;

      span {
        position: absolute;
        left: 6px;
        top: 50%;
        right: 6px;
        transform: translate(0, -50%);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
  }

  .listOn {
    color: rgb(17, 130, 251) !important;
    background: rgba(64, 158, 255, 0.1) !important;
    border: 1px solid rgba(17, 130, 251, 0.8) !important;
  }

  .el-icon-arrow-right {
    transition: 0.2s;
    cursor: pointer;
  }

  .leftTitle {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    height: 35px;
    padding-left: 10px;

    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }

  .leftTree {
    height: calc(100% - 35px);
    border-top: 1px solid #f0f0f0;
    overflow-x: hidden;
    padding: 5px 12px;

    .el-tree-node__content {
      position: relative;
    }

    .el-tree-node__expand-icon {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 99;
    }

    .el-tree-node__label {
      font-size: 12px;
    }
  }

  .el-button+.el-button {
    margin-left: 5px;
  }

  .el-button {
    font-size: 12px;
  }

  .el-tree-node__content {
    height: 20px;
    line-height: 20px;
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 3px;
  }

  .el-tree {
    color: rgba(102, 102, 102, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stationsSelect2.vue